
















































import CardComponent from '@/modules/core/components/CardComponent.vue';
import TitleBar from '@/modules/core/components/TitleBar.vue';
import HeroBar from '@/modules/core/components/HeroBar.vue';
// import ProfileUpdateForm from '@/components/ProfileUpdateForm';
// import PasswordUpdateForm from '@/components/PasswordUpdateForm';
// import Tiles from '@/components/Tiles';
import UserAvatar from '../components/UserAvatar.vue';
import UserEdit from '../components/UserEdit.vue';

import { Component, Vue } from 'vue-property-decorator';
import { User } from '../user';

import { formatDistance } from 'date-fns';
import { fr } from 'date-fns/locale';
import { mapState } from 'vuex';

@Component({
  components: {
    UserAvatar,
    // Tiles,
    // PasswordUpdateForm,
    // ProfileUpdateForm,
    HeroBar,
    TitleBar,
    CardComponent,
    UserEdit,
  },
  computed: mapState(['user']),
})
export default class Profile extends Vue {
  public user!: User;

  public get titleStack(): string[] {
    return ['Admin', 'Profil'];
  }

  public get avatarUrl(): string {
    return `https://avatars.dicebear.com/api/initials/${this.user.fullname}.svg?backgroundColors[]=grey`;
  }

  public get lastLoginText(): string {
    return this.user.lastLogin
      ? formatDistance(this.user.lastLogin instanceof Date
        ? this.user.lastLogin
        : new Date(this.user.lastLogin), new Date(), { addSuffix: true, locale: fr }
      )
      : 'N/A';
  }

  public goBack(): void {
    this.$router.go(-1);
  }
}
